import { cva } from 'class-variance-authority'

const defaultHeadingProse =
  'prose-h1:m-0 prose-h1:text-base prose-h1:font-semibold prose-h1:leading-10 prose-h1:text-main-foreground-primary'

// Table styling lives entirely in markdownTable below — don't add prose-table:* here or
// they'll fight the base.
const defaultBodyProse = [
  'prose-p:text-body-default prose-p:text-main-foreground-primary',
  'prose-a:break-all',
  'prose-pre:max-w-full',
  'prose-ul:list-disc prose-ul:pl-5',
]

const markdownTable = [
  // border-separate + border-spacing-0 is what lets overflow-hidden clip into rounded corners.
  '[&_table]:w-full',
  '[&_table]:border [&_table]:border-main-border-default',
  '[&_table]:rounded [&_table]:overflow-hidden',
  '[&_table]:border-separate [&_table]:border-spacing-0',
  // text-start because browser default for <th> is center.
  '[&_thead]:bg-main-background-tertiary',
  '[&_th]:px-3 [&_th]:py-2 [&_th]:h-9.5',
  '[&_th]:text-start [&_th]:whitespace-nowrap',
  '[&_th]:text-main-foreground-primary [&_th]:!text-label-default',
  '[&_th]:border-b [&_th]:border-main-border-default',
  // h-13 is min-height (browsers treat h-* on <td> as such); align-middle centers vertically.
  // Zero margins on prose-wrapped block children — otherwise prose-p:* margins break centering.
  '[&_td]:px-3 [&_td]:py-2 [&_td]:h-13 [&_td]:align-middle',
  '[&_td_p]:m-0',
  '[&_td]:text-main-foreground-primary [&_td]:!text-body-default',
  '[&_td]:border-t [&_td]:border-main-border-default',
  '[&_tbody_tr:first-child_td]:border-t-0',
  // 4-col tables only: give col 3 (Quote) half the width.
  '[&_table:has(th:nth-child(4))_th:nth-child(3)]:w-1/2',
  '[&_table:has(th:nth-child(4))_td:nth-child(3)]:w-1/2',
  // "What changed"-style tables (empty first header → first column is a label): promote the
  // first-column cells to label typography and draw a divider between label and value columns.
  '[&_table:has(th:first-child:empty)_td:first-child]:!text-label-default',
  '[&_table:has(th:first-child:empty)_td:first-child]:border-r [&_table:has(th:first-child:empty)_td:first-child]:border-main-border-default',
  '[&_table:has(th:first-child:empty)_th:first-child]:border-r [&_table:has(th:first-child:empty)_th:first-child]:border-main-border-default',
  // H1 immediately before a table is a subtitle; second-and-later get a top gap.
  '[&_h1:has(+table)]:!text-heading-xxsmall [&_h1:has(+table)]:text-main-foreground-primary',
  '[&_h1:has(+table)]:text-start [&_h1:has(+table)]:mb-2',
  '[&_h1:has(+table):not(:first-child)]:mt-6',
]

export const markdownVariants = cva(markdownTable, {
  variants: {
    variant: {
      default: defaultBodyProse,
      alertNote: [
        '[&_blockquote]:m-0 [&_p]:m-0',
        '[&_p]:text-body-default [&_p]:text-inherit',
        '[&_ol]:list-decimal [&_ol]:space-y-1 [&_ol]:pl-5 [&_ol]:text-inherit',
        '[&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-5 [&_ul]:text-inherit',
        '[&_li]:text-inherit',
        '[&_strong]:font-semibold [&_strong]:text-inherit',
      ],
    },
    evidenceTable: {
      true: [
        '[&_table]:w-full [&_table]:table-fixed',
        '[&_td:first-child]:w-[16rem] [&_td:first-child]:max-w-[16rem] [&_td:first-child]:truncate',
        '[&_th:first-child]:w-[16rem]',
        '[&_td]:align-middle',
        '[&_table_a]:break-words',
        // Lema-tag cells opt out of first-column truncation so every chip stays visible.
        '[&_td:has(lema-tag)]:w-auto [&_td:has(lema-tag)]:max-w-none [&_td:has(lema-tag)]:whitespace-normal [&_td:has(lema-tag)]:overflow-visible [&_td:has(lema-tag)]:[text-overflow:clip]',
      ],
      false: '',
    },
  },
  defaultVariants: {
    variant: 'default',
    evidenceTable: false,
  },
})

export { defaultHeadingProse }
